import api from '@cannect/services/api'

export interface SavedCard {
  id: number
  type?: string
  brand?: string
  holder?: string
  holder_name?: string
  first_digits?: string
  last4?: string
  last_digits?: string
  external_id?: string
  selected_default_card?: boolean
}

export async function listSavedCards(): Promise<SavedCard[]> {
  const { data } = await api.get('/payments/customers/cards')
  return data?.cards || []
}

export interface CreateCardPayload {
  number: string
  holder_name: string
  holder_document: string
  exp_month: number
  exp_year: number
  cvv: string
  brand?: string
  label?: string
  billing_address?: any
  selected_default_card?: boolean
}

export async function createCard(payload: CreateCardPayload) {
  const { data } = await api.post('/payments/customers/cards', { card_data: payload })
  return data
}

export async function deleteCard(cardId: number) {
  const { data } = await api.delete(`/payments/customers/cards/${cardId}`)
  return data
}

export async function updateCard(cardId: number, payload: Partial<{ label: string; selected_default_card: boolean }>) {
  const { data } = await api.put(`/payments/customers/cards/${cardId}`, payload)
  return data
}
